import { Button, Col, Modal, Row, Stack, Spinner, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaFilter } from "react-icons/fa";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { SensorsService } from "../../core/services/SensorsService";
import { useAppDispatch } from "../../core/redux/hooks";
import { updateAlert } from "../../core/redux/reducer/alert";
import { AsyncPaginate } from "react-select-async-paginate";
import { VehicleService } from "../../core/services/VehicleService";
import { useEffect } from "react";

interface SensorFormProps {
  control: any;
  isSubmitting: boolean;
  handleSubmit: any;
  sensor?: any;
  onSubmit: SubmitHandler<any>;
}

interface NewSensorAttachVehicleModalProps {
  visible?: boolean;
  data?: any;
  onClose?: () => void;
  onChange?: () => void;
  onSubmit?: (data?: any) => void;
}

const SensorForm: React.FC<SensorFormProps> = ({
  control,
  isSubmitting,
  handleSubmit,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const sensorOptions = [
    { value: 1, name: t("new_sensor_modal.input.sensorOptions.temperature") },
    { value: 7, name: t("new_sensor_modal.input.sensorOptions.humidity") },
  ];
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row className="mt-3">
        <Col>
          {t("sensors_generatexls_modal.vehicle")}
          <Controller
            name="vehiclePlate"
            control={control}
            rules={{ required: t("new_sensor_modal.input.required_vehicle") }}
            render={({ field, fieldState }) => (
              <>
                <AsyncPaginate
                  placeholder={t("new_sensor_modal.input.vehicle")}
                  loadOptions={(inputValue, options, additional) => {
                    return VehicleService.loadVehicleOptions(
                      inputValue,
                      options,
                      additional
                    );
                  }}
                  value={field.value}
                  onChange={(selected) => field.onChange(selected)}
                  additional={{ page: 1 }}
                />
                {fieldState.error && (
                  <Form.Text className="text-danger">
                    {fieldState.error.message}
                  </Form.Text>
                )}
              </>
            )}
          />
        </Col>
      </Row>

      <Stack
        direction="horizontal"
        className="mt-4 justify-content-center"
        gap={3}
      >
        <Button type="submit" disabled={isSubmitting} aria-busy={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner animation="border" size="sm" />{" "}
              {t("sensors_generatexls_modal.loading")}
            </>
          ) : (
            t("new_sensor_modal.button.submit")
          )}
        </Button>
      </Stack>
    </form>
  );
};

const NewSensorAttachVehicleModal: React.FC<
  NewSensorAttachVehicleModalProps
> = ({
  visible = false,
  data,
  onClose = () => {},
  onChange = () => {},
  onSubmit = (data?: any) => {},
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { control, handleSubmit, watch, formState, setValue } = useForm({
    defaultValues: {
      alertTypeId: "",
      vehiclePlate: null as { value: string; label: string } | null, // Permitir objeto ou null
      sensorTypeId: 1,
    },
  });

  const { isSubmitting } = formState;

  const handleGenerateReport: SubmitHandler<any> = async (data) => {
    try {
      const payload = {
        vehicle_id: data.vehiclePlate?.value,
        sensor_id: data.alertTypeId,
        sensor_type_id: data.sensorTypeId,
      };
      await SensorsService.create({ payload });

      dispatch(
        updateAlert({
          title: t("sensors.toast.report_available.prefix"),
          message: t("sensors.toast.report_available.link_text"),
          type: "success",
        })
      );
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || t("sensors.toast.error_occurred");
      const sensorError = error?.response?.data?.errors?.sensor_id?.[0];

      dispatch(
        updateAlert({
          title: errorMessage,
          message: sensorError || "",
          type: "error",
        })
      );
    }
  };
  useEffect(() => {
    console.log("effect attach ->", data);
    if (data?.license_plate) {
      setValue("vehiclePlate", {
        value: data.license_plate,
        label: data.license_plate,
      });
    }
  }, [data, setValue]);
  useEffect(() => {
    console.log("effect control ->", control);
  }, [control]);

  return (
    <Modal show={visible} size="lg" centered onHide={onClose}>
      <Modal.Header className="border-0 gap-2" closeButton>
        <Modal.Title>{t("new_sensor_modal.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <SensorForm
          control={control}
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
        />
      </Modal.Body>
    </Modal>
  );
};

export default NewSensorAttachVehicleModal;
